// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__CAYlb","con":"styles_con__d5yK9","title":"styles_title__Qt6vP","btn":"styles_btn__p82Mt"};